import { FormField } from "../../components/FormElements/FormFieldsRenderer";

const editPrescriptionPharmacy = (t, requiredFields, pharmacyProps, regionProps) => {
  const formFields: FormField[] = [
    {
      label: t('recipeForm.file'),
      prefix: 'PrescriptionForm',
      isRequired: requiredFields.file,
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'photo',
      name: 'file',
      photoField: 'photo',
      isDisabled: true,
    },
    {
      label: t('recipeForm.title'),
      prefix: 'PrescriptionForm',
      isRequired: requiredFields.title,
      fieldType: 'Text',
      isFullWidth: true,
      name: 'title',
      isDisabled: true,
    },
    {
      label: t('recipeForm.notes'),
      prefix: 'PrescriptionForm',
      isRequired: requiredFields.notes,
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'textarea',
      name: 'notes'
    }
  ];

  return formFields;
}

export default editPrescriptionPharmacy;
